var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'view/transactions-report', 'component/range-selector', 'core', 'template/report/landing.htm'], function($, _, TransactionsReportView, rangeSelector, core, landingViewTemplate) {
  var TransactionsReportPage;
  return TransactionsReportPage = (function(_super) {

    __extends(TransactionsReportPage, _super);

    function TransactionsReportPage() {
      TransactionsReportPage.__super__.constructor.apply(this, arguments);
    }

    TransactionsReportPage.prototype.pageId = 'transactions';

    TransactionsReportPage.prototype.initialize = function(options, params) {
      options = _.extend(options, {
        title: 'Transactions',
        icon: 'ss-list ss-standard',
        features: ['date-range', 'edit', 'search'],
        template: landingViewTemplate,
        url: function(clientId, from, to, page) {
          return "query/json/" + clientId + "?from=" + from + "&to=" + to + "&page=" + page + "&results-per-page=50";
        }
      });
      TransactionsReportPage.__super__.initialize.call(this, options, params);
      return this.loadData(this.pageNum);
    };

    return TransactionsReportPage;

  })(TransactionsReportView);
});
